export default __webpack_public_path__ + "static/tokens-d4a4f992e657ea91d28e82b5e260d1f9.png";